module.exports = {"token":"token","Token":"Token","l.token":"the token","l.Token":"The token","a.token":"a token","a.Token":"A token","user":"user","User":"User","l.user":"the user","l.User":"The user","a.user":"a user","a.User":"A user","Validate":"Validate","account.activation.successful":"Your account was successfully activated.","new.password.registered":"Your new password was successfully registered.","choose.your.new.password":"Choose your new password","new.password":"New password","confirm.new.password":"Confirm your new password"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/en.json
// module id = NuBg
// module chunks = 1